import { validate } from 'email-validator';
import { isNil } from 'lodash';

export function isEmail(input?: string): boolean {
  if (!input) {
    return false;
  }
  return validate(input);
}

export function validateEmails(input: string[] | null): boolean {
  if (isNil(input)) {
    return true;
  }
  return input.every(isEmail);
}
